import React from 'react'
import PropTypes from 'prop-types'

import Input from '../ui/Input';
import Button from '../ui/Button';
import MobSelectButton from '../ui/MobSelectButton';
import textError from './textError'
import AnimationForm from '../SelectForms/AnimationForm';
import TextList from '../SelectForms/TextList'
import { checkNotEmptyValue, findValueInCatalog } from '../utils/utils'
import { idField, translateFields } from '../utils/localCatalog';
import { sendAnalyticsEventToNative } from '../utils/analytics';

const parseNumber = data => {
  if(data)
    return data.replace(/(\d)(?=(\d\d\d)+([^\d ]|$))/g, '$1 ')
  return ''
}
class Work extends React.Component{
  constructor(props){
    super(props)
    this.state = {
      data: {
        workExpiriens: props.userData.workExpiriens || '',
        avgIncome: parseNumber(props.userData.avgIncome),
        summCredit: parseNumber(props.userData.summCredit),

        position_level: props.userData.position_level || 0,
        region: props.userData.region || 0,
        employment_type: props.userData.employment_type || 0,
        ent_segment: props.userData.ent_segment || 0,
        military_status_id: props.userData.military_status_id || 0
      },
      errorValid: false,
      nextForm: false
    }
    this.ignoreValidation = ['position_level']
  }

  componentDidMount(){
    sendAnalyticsEventToNative('ecoCreditCardOrderStep3')
  }

  componentWillUnmount(){
    const {data, nextForm} = this.state
    if(!nextForm){
      const formData = {}
      formData.jobRegionId = data.region
      formData.jobCategoryId = data.employment_type
      formData.positionId = data.position_level
      formData.employmentMonth = data.workExpiriens
      formData.salary = data.avgIncome.replace(' ', '')
      formData.amount = data.summCredit.replace(' ', '')
      formData.entSegmentCode = data.ent_segment
      formData.militaryStatusId = data.military_status_id
      this.props.onSubmitData(formData, true)
    }
  }

  onChange = (e) => {
    const regCount = /^[0-9 ]{0,7}$/
    const regSplitNumber = /(\d)(?=(\d\d\d)+([^\d ]|$))/g
    const {name, value} = e.target
    const replaceValue = value.replace(' ', '').trim()
    if(regCount.test(value)){
      let newValue = replaceValue
      if(name === 'workExpiriens')
        newValue = replaceValue.length <= 3 ? replaceValue.replace(regSplitNumber, '$1 ') : this.state.data[name]
      else if(name === 'avgIncome' || name === 'summCredit')
        newValue = replaceValue.length <= 7 ? replaceValue.replace(regSplitNumber, '$1 ') : this.state.data[name]
      this.setState({
        data: {
          ...this.state.data,
          [name]: newValue
        }
      })
    }
  }
  submit = e => {
    e.preventDefault()
    if(this.validation() && !this.checkSumm()){
      const formData = {}
      const {data} = this.state
      formData.jobRegionId = data.region
      formData.jobCategoryId = data.employment_type
      formData.positionId = data.position_level
      formData.employmentMonth = data.workExpiriens
      formData.salary = data.avgIncome.replace(' ', '')
      formData.amount = data.summCredit.replace(' ', '')
      formData.entSegmentCode = data.ent_segment
      formData.militaryStatusId = data.military_status_id
      formData.clientApprove = true
      this.setState({nextForm: true}, () => {
        this.props.onSubmitData(formData)
      })
    } else
      this.setState({
        errorValid: true
      })
  }
  validation = () => (
    Object.keys(this.state.data)
    .filter(itemFilter => !this.ignoreValidation.some(itemIgnore => itemFilter === itemIgnore))
    .every(item => {
      if(typeof this.state.data[item] === 'boolean')
        return !!this.state.data[item]
      else if(typeof this.state.data[item] === 'number')
        return this.state.data[item] !== 0
      return this.state.data[item].length !== 0 
    })
  )
  checkSumm = () => {
    const {summCredit} = this.state.data
    const replaceSumm = summCredit.replace(' ', '')
    if(replaceSumm === '' || parseInt(replaceSumm) < 1000)
      return textError.minSummCredit
    else if(parseInt(replaceSumm) > 300000)
      return textError.maxSummCredit
    return false
  }
  onSelect = (name, value) => {
    if(name === 'employment_type'){
      const {data} = this.state
      let positionLevel, regionId, ent_segment

      if(value === 1 || value === 7){
        positionLevel = data.position_level
        this.ignoreValidation = this.ignoreValidation.filter(item => item !== 'position_level')

      } else {
        positionLevel = 0
        this.ignoreValidation = [...this.ignoreValidation, 'position_level']
        this.sendHistory({
          target: {
            name: 'position_level',
            value: 0 
          }
        })
      }
      if([4,5,6].some(id => value === id)){
        regionId = 0
        ent_segment = 0
        this.ignoreValidation = [...this.ignoreValidation, 'region', 'ent_segment']
        this.sendHistory({
          target: {
            name: 'region',
            value: 0 
          }
        })
        this.sendHistory({
          target: {
            name: 'ent_segment',
            value: 0 
          }
        })
      } else {
        regionId = data.region
        ent_segment = data.ent_segment
        this.ignoreValidation = this.ignoreValidation.filter(item => item !== 'region' && item !== 'ent_segment')
      }
      this.setState({
          data: {
          ...this.state.data,
          [name]: value,
          position_level: positionLevel,
          region: regionId,
          ent_segment
        }
      }) 
    } else 
    this.setState({data: {...this.state.data, [name]: value}}) 

    this.sendHistory({
      target: {
        name,
        value
      }
    })
  }


  sendHistory = (e) => {
    const {userData } = this.props
    const name = e.target.name
    const oldValue = userData[name]
    
    let value = typeof e.target.value === 'string' ? e.target.value.replace(' ', '') : e.target.value

    const revType = oldValue === undefined ? 1 : 2
    
    if(oldValue !== value && (revType === 1 ? checkNotEmptyValue(value) : true)) {

      let newName = name === 'region' ? 'job_region' : name
  
      this.props.sendHistory({
        revType,
        fieldId: idField[newName],
        oldValue,
        newValue: value
      })

      this.props.onSubmitData({
        [translateFields[newName]]:  value
      }, true)
    }
  }

  translateText = (name, value) => {
    const findItem = TextList[name].find(item => item.id === value)
    if(findItem)
      return findItem.value
    return ''
  }
  render(){
    const {data, errorValid} = this.state
    const {
      workExpiriens, avgIncome, summCredit, position_level, region, employment_type, ent_segment, military_status_id
    } = data
    const {onShowForm, derictory} = this.props

    const isShowEntSegment = [1,2,3,7,8].some(id => id === employment_type)
    const isShowRegion = [1,2,3,7,8].some(id => id === employment_type)

    return(
      <form className="work-information" onSubmit={this.submit}>
        <AnimationForm onSelect={this.onSelect}/>
        <div className="scroll-container">
          <div className="work-info">
            <div className="form-select-container">
              <MobSelectButton
                title='Тип зайнятості'
                value={findValueInCatalog(derictory.employment_type, employment_type)}
                onClick={() => onShowForm('employment_type', 'Тип зайнятості', employment_type)}
                textValid={errorValid && (employment_type === 0)}
              />
              {(employment_type === 1 || employment_type === 7) && <MobSelectButton
                title='Посада'
                value={findValueInCatalog(derictory.position_level, position_level)}
                onClick={() => onShowForm('position_level', 'Посада', position_level)}
                textValid={errorValid && (position_level === 0)}
              />}
              {isShowRegion && <MobSelectButton
                title='Регіон роботи'
                value={findValueInCatalog(derictory.region, region)}
                onClick={() => onShowForm('region', 'Регіон роботи', region)}
                textValid={errorValid && (region === 0)}
              />}
              {isShowEntSegment && <MobSelectButton
                title='Сфера діяльності'
                value={findValueInCatalog(derictory.ent_segment, ent_segment)}
                onClick={() => onShowForm('ent_segment', 'Сфера діяльності', ent_segment)}
                textValid={errorValid && (ent_segment === 0)}
              />}
              <MobSelectButton
                title='Відношення до військової служби'
                value={findValueInCatalog(derictory.military_status_id, military_status_id)}
                onClick={() => onShowForm('military_status_id', 'Відношення до військової служби', military_status_id)}
                textValid={errorValid && (military_status_id === 0)}
              />
            </div>
            <Input
              name='workExpiriens'
              value={data.workExpiriens}
              onChange={this.onChange}
              placeholder=''
              title='Стаж роботи на поточному місці роботи в місяцях'
              maxLength={3}
              type='tel'
              marker='місяців'
              autoFocus={true}
              textValid={errorValid && workExpiriens.length === 0 && textError.emptyWorkExpiriens}
              pattern='\d*'
              onBlur={this.sendHistory}
            />
            <Input
              name='avgIncome'
              value={avgIncome}
              onChange={this.onChange}
              placeholder=''
              title='Середньомісячний дохід'
              type='tel'
              marker='грн'
              textValid={errorValid && avgIncome.length === 0 && textError.emptyAvgIncome}
              pattern='^[ 0-9]+$'
              onBlur={this.sendHistory}
            />
            <Input
              name='summCredit'
              value={summCredit}
              onChange={this.onChange}
              placeholder=''
              title='Бажана сума кредиту'
              maxLength={7}
              type='tel'
              marker='грн'
              textValid={errorValid && this.checkSumm()}
              pattern='^[ 0-9]+$'
              onBlur={this.sendHistory}
            />
          </div>
          <div className='button-container-footer'>
            <Button
              type='submit'
              title='Далі'
              color={this.validation() && !this.checkSumm() ? 'success' : 'disable'}
            />
          </div>
        </div>
      </form> 
    )
  }
}

Work.propTypes = {
  onSubmitData: PropTypes.func.isRequired,
  onShowForm: PropTypes.func.isRequired,
  userData: PropTypes.shape({
    workExpiriens: PropTypes.string,
    avgIncome: PropTypes.string,
    summCredit: PropTypes.string,
    position_level: PropTypes.number,
    region: PropTypes.number,
    employment_type: PropTypes.number,
    ent_segment: PropTypes.number,
    military_status_id: PropTypes.number,
  }).isRequired,
  derictory: PropTypes.shape({
    employment_type: PropTypes.array.isRequired,
    ent_segment: PropTypes.array.isRequired,
    military_status_id: PropTypes.array.isRequired,
    position_level: PropTypes.array.isRequired,
    region: PropTypes.array.isRequired,
  }).isRequired,
  sendHistory: PropTypes.func.isRequired
}

export default Work